import type { ActionTree, GetterTree, MutationTree } from 'vuex';
import type { RiskNote } from '@@/packages/shared/types/models/riskNote';
import type { State as RootState } from '@/store/useStore';
import { fetchRiskNotes, createRiskNote } from './api';

const initialState = () => ({
  byRiskNumber: {} as Record<string, RiskNote[]>,
});
type RiskNotesState = ReturnType<typeof initialState>;

const actions: ActionTree<RiskNotesState, any> = {
  fetchRiskNotes: async ({ commit }, riskNumber: number) => {
    const res = await fetchRiskNotes(riskNumber);
    commit('SET_RISK_NOTES', { riskNumber, notes: res.data });
  },
  createNote: async ({ commit }, { riskNumber, note }) => {
    const res = await createRiskNote(note, riskNumber);
    commit('CREATE_RISK_NOTE', { riskNumber, note: res.data });
    return res.data;
  },
};

const mutations: MutationTree<RiskNotesState> = {
  FLUSH(state) {
    Object.assign(state, initialState());
  },
  SET_RISK_NOTES(state, { riskNumber, notes }) {
    state.byRiskNumber[riskNumber] = notes;
  },
  CREATE_RISK_NOTE(state, { riskNumber, note }: { riskNumber: number; note: RiskNote }) {
    const notes = state.byRiskNumber[riskNumber] || [];
    notes.push(note);
    state.byRiskNumber[riskNumber] = notes;
  },
};

const getters: GetterTree<RiskNotesState, RootState> = {
  getRiskNotes: (state) => (riskNumber: number) => state.byRiskNumber[riskNumber] || [],
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
  getters,
};
